import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { LINK_FORMS } from '../constants'

const deleteLinkForm = async (id: number) => {
  await fetchAPI({
    path: `/forms/${id}`,
    method: 'delete',
  })
}

export const useDeleteLinkForm = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteLinkForm, {
    async onSuccess() {
      await queryClient.refetchQueries([LINK_FORMS])

      toast({
        description: t('views.admin.forms.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
